import { Dictionary } from "lodash";
import { IFieldValue, IFieldValueGroupMapping, IFieldValueGroupMappingRow, IMappingValues, MappingGroupValues } from "../../../models/models";

const saveMappingDataSet = (
    data: Map<string, Map<number, IFieldValueGroupMappingRow>>,
    allFields: Dictionary<IFieldValue[]> | undefined,
    mappingGroupKey: string,
    newItems: MappingGroupValues,
    currentUser: string | undefined) => {

    const mappingValues = {
        source: {
            systemId: newItems.mappingGroup.fromSystem.id,
            fieldValueIds: [] as Array<number> 
        },
        inserts: [] as Array<IFieldValueGroupMapping>
    } as IMappingValues;

    const mappingDataSet = data.get(mappingGroupKey);

    const fromSystemId = newItems.mappingGroup.fromSystem.id;
    const fromGroupName = newItems.mappingGroup.fromGroupName;

    const toSystemId = newItems.mappingGroup.toSystem.id;
    const toGroupName = newItems.mappingGroup.toGroupName; 

    if (mappingDataSet && allFields) {

        for (const sourceDataItem of newItems.sourceData) {
            const sourceField = allFields[sourceDataItem.label].find(x => x.value === sourceDataItem.value && x.systemId === fromSystemId);
            if (sourceField) {
                const newMapping = {
                    id: 0,
                    fieldValueId: sourceField.id,
                    fieldValue: sourceField.value,
                    fieldName: sourceField.fieldName,
                    fieldId: sourceField.fieldId,
                    systemName: sourceField.systemName,
                    systemId: sourceField.systemId,
                    groupId: 0,
                    groupName: fromGroupName,
                    modifiedBy: currentUser ?? "system"
                };
                mappingValues.source.fieldValueIds.push(sourceField.id);
                mappingValues.inserts.push(newMapping);
            }
        }

        for (const targetDataItem of newItems.targetData) {
            const targetField = allFields[targetDataItem.label].find(x => x.value === targetDataItem.value && x.systemId === toSystemId);
            if (targetField) {
                const newMapping = {
                    id: 0,
                    fieldValueId: targetField.id,
                    fieldValue: targetField.value,
                    fieldName: targetField.fieldName,
                    fieldId: targetField.fieldId,
                    systemName: targetField.systemName,
                    systemId: targetField.systemId,
                    groupId: 0,
                    groupName: toGroupName,
                    modifiedBy: currentUser ?? "system"
                };
                mappingValues.inserts.push(newMapping);
            }
        }
    }

    return mappingValues;
};

export default saveMappingDataSet;